export default __webpack_public_path__ + "static/media/Broadform-Homeowners-Insurance-Policy-April-2023.3ef9e340.pdf";